const url={
	devUrl:'https://b.vormor.cn',//'http://192.168.110.114:8200',//
	//proUrl:'http://192.168.110.114:8200',
	proUrl:'https://b.vormor.cn',
}
export const baseUrl =process.env.NODE_ENV === 'development'? url.devUrl: url.proUrl;